import { useEffect } from "react";
import SiteConfiguration from "../views/admin/siteConfiguration/SiteConfiguration";
import { AppLayout } from "@amzn/awsui-components-console";
import { PAGE_TITLES } from "src/app/constants";
import SideMenu from "src/components/sideMenu/SideMenu";

const SiteConfigurationPage = () => {
  /**
   * Changes the browser tab/menu bar title to Nucleus Sites Admin Panel when page loads
   */
  useEffect(() => {
    document.title = PAGE_TITLES.SITE_CONFIGURATION;
  }, []);
  return (
    <AppLayout
      content={<SiteConfiguration />}
      navigation={<SideMenu />}
      toolsHide={true}
      contentType="form"
      footerSelector="#app-footer"
      headerSelector="#app-header"
      ariaLabels={{
        navigationClose: "Close side menu",
        navigationToggle: "Open Side menu",
      }}
    />
  );
};
export default SiteConfigurationPage;
